// JournalArticleForm migration: 2. XML export — map article/journal/issue form data for builders
import type { JournalArticle } from '@generated/form-types/journal-article';
import type { ResourceFieldsImported } from '@/common/types';
import { FormData } from '@content-registration/types';
import { mapData } from '@content-registration/xml/mapping/transforms';

/**
 * Adapts Journal Article record shape to MetadataConverterAPI form data.
 * Maps landingPageUrl to resourceUrl for the MetadataConverterAPI article payload.
 */
export const adaptJournalArticleToMetadataConverterAPIFormData = (
  data: JournalArticle
): FormData => {
  const article = data.article;
  const journal = data.journal;

  return {
    article: {
      title: article.title,
      doi: article.doi,
      resourceUrl: article.landingPageUrl,
      contributors: article.contributors,
      abstract: article.abstract,
      publicationDates: article.publicationDates,
      pageOrArticleNumber: article.pageOrArticleNumber,
      funding: article.funding,
      license: article.license,
      simCheckUrl: article.simCheckUrl,
      relationships: article.relationships,
      references: article.references,
    },
    journal: {
      titles: journal?.titles,
      issn: journal?.issn,
      crossmarkPolicyPage: journal?.crossmarkPolicyPage,
      doi: journal?.doi,
      resourceUrl: journal?.resourceUrl,
    },
    issue: data.issue,
  };
};

/** Maps Journal Article form data to the MetadataConverterAPI payload. */
export const mapJournalArticleData = (
  input: FormData,
  hadData?: ResourceFieldsImported
) =>
  mapData(
    adaptJournalArticleToMetadataConverterAPIFormData(
      input as unknown as JournalArticle
    ),
    hadData
  );
